export default __webpack_public_path__ + "static/media/1.48ff840d.png";